import { QueryClient } from '@tanstack/react-query';

/**
 * Create and configure the React Query client with default options
 * @returns {QueryClient} Configured React Query client
 */
export const createQueryClient = () => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        retry: 1,
        staleTime: 1000 * 60 * 5, // 5 minutes
        cacheTime: 1000 * 60 * 30, // 30 minutes
      },
    },
  });
};

/**
 * Hook for working with React Query configuration
 * @returns {Object} Object containing the queryClient and default query keys
 */
export const useQueryConfig = () => {
  // Define query keys structure to prevent typos and maintain consistency
  const queryKeys = {
    auth: {
      me: ['auth', 'me'],
    },
    projects: {
      all: ['projects'],
      detail: (id) => ['projects', id],
      apiKey: (id) => ['projects', id, 'apiKey'],
    },
    chatbot: {
      costs: (projectId, params) => ['chatbot', 'costs', projectId, params],
      sessions: (projectId, params) => ['chatbot', 'sessions', projectId, params],
      history: (sessionId) => ['chatbot', 'history', sessionId],
    },
    knowledgeBase: {
      all: (projectId) => ['knowledgeBase', projectId],
      detail: (id) => ['knowledgeBase', 'detail', id],
      search: (projectId, query) => ['knowledgeBase', 'search', projectId, query],
    },
  };

  return {
    queryKeys,
  };
};

export default useQueryConfig; 